
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { PurchaseListGroupedResponse, PurchaseListItem } from '@/types/purchase-list';
import PurchaseListItemRow from '@/components/purchase-order/PurchaseListItemRow.vue';
import { CurrencyHelper } from '@/helpers/CurrencyHelper';

@Component({ components: { PurchaseListItemRow } })
export default class PurchaseListSidebar extends Vue {
  @Prop({ required: true }) public readonly groups!: PurchaseListGroupedResponse['groups'];
  public collapsed = false;

  public get total(): number {
    return Object.values(this.groups).reduce((n, g) => n + g.items.length, 0);
  }

  public get subtotalByCurrency(): Record<string, number> {
    const totals: Record<string, number> = {};
    for (const group of Object.values(this.groups)) {
      const code = group.currencyCode || 'USD';
      const groupSum = group.items.reduce(
        (s, i) => s + Number(i.quantity) * Number(i.unitCost), 0,
      );
      totals[code] = (totals[code] || 0) + groupSum;
    }
    return totals;
  }

  public get subtotalDisplay(): string {
    const parts = Object.entries(this.subtotalByCurrency)
      .map(([code, total]) => CurrencyHelper.formatCurrencyWithCode(total, code));
    return parts.length ? parts.join(', ') : CurrencyHelper.formatCurrencyWithCode(0, 'USD');
  }

  public formatGroupSubtotal(group: { items: PurchaseListItem[]; currencyCode?: string }): string {
    const sum = group.items.reduce(
      (s, i) => s + Number(i.quantity) * Number(i.unitCost), 0,
    );
    return CurrencyHelper.formatCurrencyWithCode(sum, group.currencyCode || 'USD');
  }

  public onRowQty(item: PurchaseListItem, quantity: number): void {
    // The row component already parsed and validated the value.
    this.$emit('qty', { ...item, quantity });
  }
  public onRemove(item: PurchaseListItem): void { this.$emit('remove', item); }
  public onReview(): void { this.$router.push('/purchase-orders/purchase-list/review'); }
}
